import {
  LOYALTY_POINTS_AVAILABILITY_REQUESTING,
  GET_LOYALTY_POINTS_AVAILABILITY_SUCCESS,
  RESET_LOYALTY_POINTS_AVAILABILITY_ISFETCHING
} from './constants';

const INITIAL_STATE = {
  data: null,
  isFetching: false
};

const reducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case RESET_LOYALTY_POINTS_AVAILABILITY_ISFETCHING: {
      return {
        ...state,
        isFetching: false
      };
    }
    case LOYALTY_POINTS_AVAILABILITY_REQUESTING: {
      return {
        ...state,
        isFetching: true
      };
    }
    case GET_LOYALTY_POINTS_AVAILABILITY_SUCCESS: {
      return {
        ...state,
        data: action.payload,
        isFetching: false
      };
    }
    default:
      return state;
  }
};

export default reducer;
